// extracted by mini-css-extract-plugin
module.exports = {"style":{"fontFamily":"'__Montserrat_6e8a25', '__Montserrat_Fallback_6e8a25'"},"className":"__className_6e8a25","variable":"__variable_6e8a25"};